const getters = {
  getBenefitCategories: (state) => state.benefitCategories,
  getBenefitCategory: (state) => state.benefitCategory,
};

export default getters;